import React from 'react'

const TickIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.40913 17.5568L2.43868 12.5864C1.88004 12.0278 0.977619 12.0278 0.418979 12.5864C-0.13966 13.145 -0.13966 14.0474 0.418979 14.6061L6.40645 20.5936C6.96509 21.1522 7.8675 21.1522 8.42614 20.5936L23.581 5.43867C24.1397 4.88004 24.1397 3.97762 23.581 3.41898C23.0224 2.86034 22.12 2.86034 21.5613 3.41898L7.40913 17.5568Z" />
    </svg>
  )
}

export default TickIcon
